// extracted by mini-css-extract-plugin
export var profileTableHeader = "profile-table-header_ntbUgePjTTmc1tTscEYY";
export var profileTableHeaderSeparator = "profile-table-header__separator_JueItjJg27eQwWCllVFr";
export var profileTableHeaderTotalCount = "profile-table-header__total-count_gF955_8KDPd5lHdNvshk";